<div id="boats-container" [ngStyle]="{'visibility':(this.boatsVisible)?'visible':'hidden','height': (this.boatsExpanded)?'550px':'48px'}" cdkDrag>
  <div id="boats-handle" cdkDragHandle>
      <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
        <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
        <path d="M0 0h24v24H0z" fill="none"></path>
      </svg>
  </div>  
  
  <div id="boats-expand">
    <mat-icon *ngIf="!this.boatsExpanded" id="boats-expand-more" (click)="boatsExpandToggle()">expand_more</mat-icon>
    <mat-icon *ngIf="this.boatsExpanded" id="boats-expand-less" (click)="boatsExpandToggle()">expand_less</mat-icon>
  </div>  

  <div id="boats-header">
    <strong>Select class, boat and rank</strong>
    <div style="padding-top:2px" [ngStyle]="{'visibility':(this.boatsExpanded)?'hidden':'visible'}">
      N.{{this.api.boatsLeaderBoards.length}} boats selected 
    </div>    
  </div>

  <div id="boatsClassList" [ngStyle]="{'visibility':(this.boatsExpanded)?'visible':'hidden'}">
    <div class="boatClassItem">
      <mat-icon style="font-size:20px;cursor:pointer;vertical-align: middle" [ngStyle]="{'color': (this.api.boatClassesAllVisible) ? 'red' : 'gray'}" 
      (click)="this.api.toggleclassVisibilityAll()">done_outline</mat-icon>
      ALL CLASSES
    </div>
    <div class="boatClassItem" *ngFor="let bClass of this.api.boatClasses; index as i">
      <mat-icon style="font-size:20px;cursor:pointer;vertical-align: middle" 
        [ngStyle]="{'color': (this.api.boatClasses[i].visible) ? 'red' : 'gray'}"
      (click)="this.api.toggleclassVisibility(i)">
      done_outline
    </mat-icon>
      {{bClass.name | slice:0:9}}
    </div>
  </div>

  <div id="boatsFilter" [ngStyle]="{'visibility':(this.boatsExpanded)?'visible':'hidden'}">
    <mat-icon style="font-size:20px;cursor:pointer;vertical-align: middle">search</mat-icon>
    <input matInput #filterInput (keyup)="this.api.changeLeaderboardFilter(filterInput.value)" style="width:50px" placeholder="Search">
    <mat-icon style="padding-left:12px;font-size:20px;cursor:pointer;vertical-align: middle">swap_vert</mat-icon>
    
    <!-- ATTENZIONE NON RIDURRE LA DIMENSIONE SENZA TEST SU SAFARI/APPLE !!! -->
    <mat-select [value]="1" style="width:160px" (selectionChange)="this.api.changeLeaderboardOrder($event.value)">
      <mat-option  [value]="1">Name</mat-option>
      <mat-option  [value]="2">Distance to arrival</mat-option>
      <mat-option  [value]="3">Estimated arrival</mat-option>
      <mat-option  [value]="4">Estimated arrival TCC</mat-option>
      <mat-option  [value]="5">Speed to destination</mat-option>
      <mat-option  [value]="6">Last message received</mat-option>
    </mat-select>  
  </div>
  
  <!-- 
    (mouseover)="this.api.leaderBoardBoatClick(boat.boatId,'mouseover')"
    (mouseout)="this.api.leaderBoardBoatClick(boat.boatId,'mouseout')" 
    (mouseover)="this.api.leaderBoardBoatClick(boat.boatId,'mouseover')"
    (mouseleave)="this.api.leaderBoardBoatClick(boat.boatId,'mouseleave')" 
    (click)="this.api.leaderBoardBoatClick(boat.boatId,'click')"
    (touchstart)="this.api.leaderBoardBoatClick(boat.boatId,'touchstart')">
  -->

  <div id="boatsList" [ngStyle]="{'visibility':(this.boatsExpanded)?'visible':'hidden'}">
    <div class="boatsItem" *ngFor="let boat of this.api.boatsLeaderBoardsObservable | async; index as i" style="cursor:pointer"
    (click)="this.api.leaderBoardBoatClick(boat.boatId,'click')" 
    (mouseenter)="this.api.leaderBoardBoatClick(boat.boatId,'mouseenter')"
    (mouseleave)="this.api.leaderBoardBoatClick(boat.boatId,'mouseleave')" >
      <div>
        <!-- <mat-icon svgIcon="sailboat" class="boatIcon" [ngStyle]="{'color': boat.iconColor}" ></mat-icon>   -->
        <mat-icon *ngIf="boat.class=='MARKER'" svgIcon="buoy" class="boatIcon" [ngStyle]="{'color': black}" ></mat-icon>  
        <mat-icon *ngIf="boat.class!='MARKER'" svgIcon="sailboat" class="boatIcon" [ngStyle]="{'color': boat.iconColor}" ></mat-icon>
        {{boat.name | slice:0:24}} ({{boat.class|slice:0:9}}) <br>
        <mat-icon class="boatVisibleIcon" [ngStyle]="{'visibility': (boat.fullTrackVisible) ? 'visible' : 'hidden'}">visibility</mat-icon>  
        <!-- Tentativo gestione
        <span *ngIf="boat.nav_status==0">Last position at: {{boat.last_msg_datetime}}<br></span>
        <span *ngIf="boat.nav_status==10"><span style="color:red;">D  NC</span> - Last position at {{boat.last_msg_datetime}}<br></span>
        <span *ngIf="boat.nav_status==20"><span style="color:red;">DNF</span> - Last position at {{boat.last_msg_datetime}}<br></span>
        <span *ngIf="boat.nav_status==50">Distance {{boat.nav_dtg_tot | number:'1.1-1'}} NM at {{boat.last_msg_datetime}}<br></span> 
        -->
        <span *ngIf="boat.nav_status==0 && boat.class!='MARKER'">Last position at: {{boat.last_msg_datetime}}<br></span>
        <span *ngIf="boat.nav_status==10 && boat.class!='MARKER'"><span style="color:red;">DNC</span> - Last position at {{boat.last_msg_datetime}}<br></span>
        <span *ngIf="boat.nav_status==20 && boat.class!='MARKER'"><span style="color:red;">DNF</span> - Last position at {{boat.last_msg_datetime}}<br></span>
        <span *ngIf="boat.nav_status==50 && boat.class!='MARKER'">Distance {{boat.nav_dtg_tot | number:'1.1-1'}} NM at {{boat.last_msg_datetime}}<br></span>
        <span *ngIf="boat.nav_status==100 && boat.class!='MARKER'"><span style="color:green;">Arrived</span> at {{boat.nav_toa_text}}<br></span>
        <span *ngIf="boat.class=='MARKER'">Last position at: {{boat.last_msg_datetime}}<br></span>

      </div>
      <!-- {{boat.name}} {{boat.last_msg_epoch}} {{boat.last_msg_datetime}} -->
    </div>
  </div>
  <div id="boatsCounter" [ngStyle]="{'visibility':(this.boatsExpanded)?'visible':'hidden'}">
    N.{{this.api.boatsLeaderBoards.length}} boats selected 
  </div>
</div>
  
        
<!-- /////////////////////////////////////////////////////////////////////////////////////////////////////       -->

<!-- <div id="toolbar" cdkDrag>
    Toobar
    <div id="toolbar-handle" cdkDragHandle>
        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
          <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
          <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
      </div>
      <mat-icon>done</mat-icon>
      <mat-icon>layer</mat-icon>
      <mat-icon>grid_on</mat-icon>
      <mat-icon>grid_off</mat-icon>
</div>
 -->
<!-- /////////////////////////////////////////////////////////////////////////////////////////////////////       -->